module.exports = __webpack_public_path__ + "img/ico-arrow-down-grey.b1e8bccb.svg";